//Imports
import { DoArraysOverlap } from "../../../../shared/scripts/array-functions";
import { plainToClass } from "class-transformer";
import { DataHubRepository, MetadataField } from './data-sharing-hub.objects';


// Class implementation for DataHubPage
export class DataHubPage {
    private repositories: DataHubRepository[];
    private dataTable: any;
    documentViewModal: JQuery<HTMLElement>;

    private metadataTable: any;
    private metadataFields: MetadataField[];

    connectModal: JQuery<HTMLElement>;
    connectForm: HTMLFormElement;
    connectSpinner: JQuery<HTMLElement>;
    connectSubmitBtn: JQuery<HTMLElement>;
    connectSuccessBlock: JQuery<HTMLElement>;
    connectErrorBlock: JQuery<HTMLElement>;

    indexedRepositoryModal: JQuery<HTMLElement>;
    nonIndexedRepositoryModal: JQuery<HTMLElement>;
    viewVideoModal: JQuery<HTMLElement>;
   
    private filterOptions = {
        assetType: [
            "Data Collections", "Sequence", "Genomic", "Transcriptomic",
            "Phenotypic", "CryoEM", "Tomogram", "Imaging", "Generalist",
            "Code/Tool", "Mass Spectrometry", "Proteomic", "Metabolomic",
            "Structure", "Protocol/Method", "Metagenomic", "Immune Monitoring"
        ],
        automaticallyRegistered: ["Yes", "No", "Sometimes"],
        organismRestrictions: ["Unrestricted", "Human Only"],
        supportsEmbargo: ["Yes", "No"],
        accessControl: ["Yes", "No"],
        curationServices: ["Yes", "No"],
        cost: ["Free", "Paid Services"]
    };

    constructor(data: any, metadataFieldsJson: any) {
        this.repositories = plainToClass(DataHubRepository, <DataHubRepository[]>data)
        this.metadataFields = plainToClass(MetadataField, <MetadataField[]>metadataFieldsJson);

        $(() => {
            this.createFilterHtml();
            this.initializeTable();
            this.initializeModalTables();
           // this.setupFilterListeners();
            //this.setupFiltering();
            this.setupScrollHighlight();
            this.initializeConnectForm();
            this.initializeStepBtns();
            this.initializeMetadataTable();
        });

        this.documentViewModal = $("#view-document-modal");
        this.indexedRepositoryModal = $("#indexed-repository-modal");
        this.nonIndexedRepositoryModal = $("#non-indexed-repository-modal");
        this.viewVideoModal = $("#view-video-modal");

        // resize tables on navbar collapse/show
        $(".nav-column").on("shown.bs.collapse hidden.bs.collapse", () => {
            // delay to let collapse animations complete
            setTimeout(() => {
                if (this.dataTable) {
                    this.dataTable.columns.adjust();
                }

                if (this.metadataTable) {
                    this.metadataTable.columns.adjust();
                }
            }, 250)           
        })

        this.initializeViewDocumentModal();
    }

    //Create Filters
    private createFilterHtml(): void {
        const filterHtml = `
              <div class="filter-container" style="margin-bottom: 20px;">
           
            <div class="row">
                ${Object.keys(this.filterOptions).map((key) => `
                    <div class="col-12 col-md-3 mb-2">
                        <div id="${key}-filter-block" class="filter-label d-inline-block label-only">
                           ${key === 'organismRestrictions' ? 'Restrictions' : this.toTitleCase(key)}

                        </div>
                        <div class="dropdown bootstrap-select show-tick w-100">
                            <select id="${key}" class="${key}-filter selectpicker" 
                                    title="None Selected" 
                                    data-actions-box="true" 
                                    data-width="100%" 
                                    data-container="body" 
                                    data-size="10" 
                                    multiple>
                                ${this.filterOptions[key].map(option => `
                                    <option value="${option}" selected>${option}</option>
                                `).join('')}
                            </select>
                        </div>
                    </div>
                `).join('')}
                <!-- Placeholder for the search box -->
                <div class="col-12 col-md-3 mb-2">
                    <div id="searchContainer" class="filter-label"></div>
                </div>
            </div>
        </div>
    `;

        // Add the filter HTML to the DOM
        $("#filter-container").html(filterHtml);

        // Initialize the selectpickers globally
        $('.selectpicker').selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",
            countSelectedText: (numSelected, numTotal) => {
                return numSelected === numTotal ? "All" : `${numSelected} Selected`;
            }
        });

        // Add event listener for filter changes
        $('.selectpicker').on('changed.bs.select', () => {
            this.triggerFilter();
        });

        // Button for clear filters functionality
        $('#clear-filters-btn').on('click', () => {
            // Clear all selectpicker filters and reset all options to "selected"
            $('.selectpicker').each(function () {
                $(this).find('option').prop('selected', true); // Select all options
                $(this).selectpicker('refresh'); // Refresh the UI to reflect the changes
            });

            // Clear the DataTables search input
            $('#data-hub-table_filter input[type="search"]').val('').trigger('input'); // Clear search and trigger the search functionality

            // Reset the data table to show all items
            this.updateTable(this.repositories);

        });
    }

    //Private trigger filter
    private triggerFilter(): void{
        let filteredItems = this.repositories;
        //Asset Type
        let assetTypesSelected = $(`#assetType`).val()
        filteredItems = filteredItems.filter(repository => DoArraysOverlap(assetTypesSelected, repository.DataTypes))
        //indexed by NIAID
        //What is left 
        let indexedSelected = <string[]>$('#automaticallyRegistered').val()

        filteredItems = filteredItems.filter(repository => {
            let stringValue = "No"
            if (repository.IsAutomaticallyRegistered == 1) stringValue = "Yes";
            else if (repository.IsAutomaticallyRegistered == 2) stringValue = "Sometimes";
            return DoArraysOverlap(indexedSelected, [stringValue]) 

        })
        //Organism Restrictions
        let organismRestrictionsSelected = $(`#organismRestrictions`).val()
        filteredItems = filteredItems.filter(repository => DoArraysOverlap(organismRestrictionsSelected, repository.OrganismRestrictions))

        //Supports Embargo
        let supportsEmbargoSelected = $(`#supportsEmbargo`).val()
        filteredItems = filteredItems.filter(repository => DoArraysOverlap(supportsEmbargoSelected, repository.SupportsEmbargo))

        //Access Controls
        let accessControlsSelected = $(`#accessControl`).val()
        filteredItems = filteredItems.filter(repository => DoArraysOverlap(accessControlsSelected, repository.AccessControlCapability))

        //Curation Services
        let curationServicesSelected = $(`#curationServices`).val()
        filteredItems = filteredItems.filter(repository => DoArraysOverlap(curationServicesSelected, repository.CurationServices))

        //cost
        let costSelected = $(`#cost`).val()
        filteredItems = filteredItems.filter(repository => DoArraysOverlap(costSelected, repository.Cost))


        this.updateTable(filteredItems)
   
    }

    private initializeModalTables(): void {
        let indexedRepositories = this.repositories.filter(repo => repo.IsAutomaticallyRegistered == 1 || repo.IsAutomaticallyRegistered == 2);

        let indexedRepoTable = $('#indexed-repository-table').DataTable({
            data: indexedRepositories,
            columns: [
                { data: "Name", title: "Repository", className: "text-left font-size12 font-weight-bold nowrap" },
                { data: "Description", title: "Description", className: "text-left font-size12 nowrap" },
                {
                    data: "IsAutomaticallyRegistered", title: "Automatically Registered", className: "text-left font-size12 nowrap", render: (data) => { return this.renderAutomaticallyRegistered(data) } 
                },
                { data: "DataTypes", title: "Asset Type(s)", className: "text-left font-size12 nowrap", render: (data) => Array.isArray(data) ? data.join(', ') : 'Not specified' },
                {
                    title: "Links",
                    render: (data: any, type: string, row: any) => `
                    <div>
                        <a href="${row.GuidanceLink}" target="_blank" class="text-left font-size12 nowrap guidancelink">Guidance Link <i class="fa-solid fa-up-right-from-square"style="text-decoration:none; margin-left:3px;"></i></a> 
                        <hr style="border: 0; border-top: 1px solid #dee2e6; margin: 8px 0;">

                        <a href="${row.RepositoryLink}" target="_blank" class="guidancelink">Visit Repository<i class="fa-solid fa-up-right-from-square"style="text-decoration:none; margin-left:3px;"></i></a> 
                    </div>`
                },
                { data: "Cost", title: "Cost", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "AccessControlCapability", title: "Access Control", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "OrganismRestrictions", title: "Restrictions", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "SupportsEmbargo", title: "Supports Embargo", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "CurationServices", title: "Curation Services", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' }
            ],
            paging: false,
            searching: false,
            info: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
        });

        this.indexedRepositoryModal.on("shown.bs.modal", () => {
            indexedRepoTable.columns.adjust();
        });

        let nonIndexedRepositories = this.repositories.filter(repo => repo.IsAutomaticallyRegistered == 0 || repo.IsAutomaticallyRegistered == 2);

        let nonIndexedRepoTable = $('#non-indexed-repository-table').DataTable({
            data: nonIndexedRepositories,
            columns: [
                { data: "Name", title: "Repository", className: "text-left font-size12 font-weight-bold nowrap" },
                { data: "Description", title: "Description", className: "text-left font-size12 nowrap" },
                {
                    data: "IsAutomaticallyRegistered", title: "Automatically Registered", className: "text-left font-size12 nowrap", render: (data) => { return this.renderAutomaticallyRegistered(data) } 
                },
                { data: "DataTypes", title: "Asset Type(s)", className: "text-left font-size12 nowrap", render: (data) => Array.isArray(data) ? data.join(', ') : 'Not specified' },
                {
                    title: "Links",
                    render: (data: any, type: string, row: any) => `
                    <div>
                        <a href="${row.GuidanceLink}" target="_blank" class="text-left font-size12 nowrap guidancelink">Guidance Link <i class="fa-solid fa-up-right-from-square"style="text-decoration:none; margin-left:3px;"></i></a> 
                        <hr style="border: 0; border-top: 1px solid #dee2e6; margin: 8px 0;">

                        <a href="${row.RepositoryLink}" target="_blank" class="guidancelink">Visit Repository<i class="fa-solid fa-up-right-from-square"style="text-decoration:none; margin-left:3px;"></i></a> 
                    </div>`
                },
                { data: "Cost", title: "Cost", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "AccessControlCapability", title: "Access Control", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "OrganismRestrictions", title: "Restrictions", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "SupportsEmbargo", title: "Supports Embargo", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "CurationServices", title: "Curation Services", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' }
            ],
            paging: false,
            searching: false,
            info: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
        });

        this.nonIndexedRepositoryModal.on("shown.bs.modal", () => {
            nonIndexedRepoTable.columns.adjust();
        });
    }

    navigateIndexedRepositories(): void {
        this.indexedRepositoryModal.modal("show");
    }

    navigateNonIndexedRepositories(): void {
        this.nonIndexedRepositoryModal.modal("show");
    }

    //matching repository updates from 
    updateTable(matchingRepos: DataHubRepository[]): void {

        this.dataTable.clear();
        this.dataTable.rows.add(matchingRepos).draw();
       
    }
    private initializeTable(): void {
        this.dataTable = $('#data-hub-table').DataTable({
            data: this.repositories,
            columns: [
                {
                    title: "Repository",
                    render: (data: any, type: string, row: any) => `
                    <div style="display: flex; align-items: center;" class="toggle-details"">
                        <i class="fa-solid fa-circle-plus" style="margin-right: 9px; font-size: 15px;"></i>
                        <span style="font-weight:600;">${row.Name}</span>
                    </div>`
                },
                { data: "Description", title: "Description", className: "text-left font-size12 nowrap" },
                {
                    data: "IsAutomaticallyRegistered", title: "Automatically Registered", className: "text-left font-size12 nowrap", render: (data) => { return this.renderAutomaticallyRegistered(data) } 
                },
                { data: "DataTypes", title: "Asset Type(s)", className: "text-left font-size12 nowrap", render: (data) => Array.isArray(data) ? data.join(', ') : 'Not specified' },
                {
                    title: "Links",
                    render: (data: any, type: string, row: any) => `
                    <div>
                        <a href="${row.GuidanceLink}" target="_blank" class="text-left font-size12 nowrap guidancelink">Guidance Link <i class="fa-solid fa-up-right-from-square"style="text-decoration:none; margin-left:3px;"></i></a> 
                        <hr style="border: 0; border-top: 1px solid #dee2e6; margin: 8px 0;">

                        <a href="${row.RepositoryLink}" target="_blank" class="guidancelink">Visit Repository<i class="fa-solid fa-up-right-from-square"style="text-decoration:none; margin-left:3px;"></i></a> 
                    </div>`
                },
                { data: "Cost", title: "Cost", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "AccessControlCapability", title: "Access Control", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "OrganismRestrictions", title: "Restrictions", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "SupportsEmbargo", title: "Supports Embargo", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' },
                { data: "CurationServices", title: "Curation Services", className: "text-left font-size12 nowrap", visible: false, render: (data) => data || 'Not specified' }
            ],
            paging: false,
            searching: true,
            info: false,/*Turn off count div at bottom*/
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,

        });
        const searchBox = $('#data-hub-table_filter'); // Locate the default search box
        $('#searchContainer').append(searchBox);//Attach to new item
     

        this.setupToggleDetails();
    }

    initializeMetadataTable(): void {
        this.metadataTable = $('#metadata-fields-table').DataTable({
            dom: 'Bt',
            data: this.metadataFields,
            columns: [
                { data: "FieldName", title: "Metadata Field", className: "text-left font-size12 bold-table-column nowrap" },
                { data: "IsRequired", title: "Required", className: "text-left font-size12 nowrap", render: (data) => data ? "Yes" : "No" },
                { data: "Description", title: "Description", className: "text-left font-size12" },
            ],
            autoWidth: true,
            paging: false,
            searching: false,
            info: false,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            fixedColumns: {
                leftColumns: 1
            },
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: 'ReVAMPP_DDE_Metadata_Fields'
                }
            ],
            orderCellsTop: true,
            order: [[1, "desc"], [0, "asc"]],
            initComplete: (settings, json) => { }
        });

        let metadataTable = this.metadataTable;
        $(".expand-step-block").each(function () {
            let expandItem = $(this).find(".collapse").first();
            expandItem.on("shown.bs.collapse", () => {
                metadataTable.columns.adjust();
            })
        })
    }

    initializeStepBtns(): void {
        let stepBtns = $(".step-btn");
        stepBtns.on("click", (e) => {
            let btnTarget = $(e.currentTarget);
            let stepSection = btnTarget.closest(".expand-step-section");
            let nextSection = stepSection.next(".expand-step-section");
            let nextSectionExpandContent = nextSection.find(".expand-step-block").find(".collapse").first();

            nextSectionExpandContent.collapse("show");
        });
    }

    downloadMetadataTable(): void {
        let downloadBtn = $("#metadata-fields-table").closest(".revampp-datatable").find(".dt-buttons").find(".buttons-csv");
        downloadBtn.trigger("click");
    }

    private renderAutomaticallyRegistered(data: number): string {
        if (data == 0) {
            return `
                <div class='d-flex align-items-center'>
                    <div class="pr-2 red-register-icon"><i class="fa-solid fa-circle-xmark fa-lg"></i></div>
                    <div>No</div>
                </div>
            `
        }
        else if (data == 1) {
            return `
                <div class='d-flex align-items-center'>
                    <div class="pr-2 green-register-icon"><i class="fa-solid fa-circle-check fa-lg"></i></div>
                    <div>Yes</div>
                </div>
            `
        }
        else {
            return `
                <div class='d-flex align-items-center'>
                    <div class="pr-2 yellow-register-icon"><i class="fa-solid fa-circle-half-stroke fa-lg"></i></div>
                    <div>Sometimes</div>
                </div>
            `
        }
    }

//Logic for capitalizing in filters
    private toTitleCase(str: string): string {
        return str
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between a lowercase and uppercase letter
            .replace(/^./, firstChar => firstChar.toUpperCase()); // Capitalize just the first letter - Remove NIAID spacing
    }

    private setPeopleFoundLabel(count: number): void {
        // $(".count-found").html(`<div class="table-message d-inline-block align-self-center">Repositories found: ${count}</div>`);
    }

//Fix updating index following filtering
    private setupToggleDetails(): void {
        $('#data-hub-table tbody').on('click', '.toggle-details', (event) => {
            const clickedDiv = $(event.currentTarget); // The clicked div
          

            // Try to find the <i> element dynamically
            const row = clickedDiv.closest('tr'); // The parent table row
            let toggleDetails = row.find(".toggle-details");
            const rowData = this.dataTable.row(row).data(); // Get the correct row data
            const detailsRow = row.next('tr.details-row'); // Check if a details row exists
          
            // Toggle the details row
            if (detailsRow.length) {
                toggleDetails.removeClass("is-open");
                detailsRow.remove();
            } else {
                const newRow = `
                <tr class="details-row">
                    <td colspan="${this.dataTable.columns().count()}" style="padding: 0;">
                        ${rowData.getDetailsHtml()}
                    </td>
                </tr>`;
                $(newRow).insertAfter(row);
                toggleDetails.addClass("is-open");
            }

          
        });
    }

    private setupScrollHighlight(): void {
        const navItems = $('.nav-items');
        const blockLinkBtns = $(".block-btn-link");

        // Smooth scrolling to the section when clicking a nav item
        navItems.on('click', function (event) {
            event.preventDefault();
            const targetSection = $(this).attr('href');
            if (!targetSection) return; // Ensure the href is valid

            const navbar = $("header").find("nav");
            let navheight = navbar.outerHeight();
            let padHeight = 50;

            const sectionOffset = $(targetSection).offset().top;

            let targetOffset = sectionOffset - navheight - padHeight;
            if (targetOffset < 0) targetOffset = 0;

            $('html, body').animate({ scrollTop: targetOffset }, 800);

            // Remove 'active' class from all and add to the clicked item
            navItems.removeClass('active');
            $(this).addClass('active');
        });

        blockLinkBtns.on('click', function (event) {
            event.preventDefault();
            const targetSection = $(this).attr('href');
            if (!targetSection) return; // Ensure the href is valid

            const navbar = $("header").find("nav");
            let navheight = navbar.outerHeight();
            let padHeight = 50;

            const sectionOffset = $(targetSection).offset().top;

            let targetOffset = sectionOffset - navheight - padHeight;
            if (targetOffset < 0) targetOffset = 0;

            $('html, body').animate({ scrollTop: targetOffset }, 800);
        });

        // Highlight the correct nav item based on scroll position
        $(window).on('scroll', () => {
            const scrollY = $(window).scrollTop();

            const navbar = $("header").find("nav");
            let navheight = navbar.outerHeight();
            let padHeight = 150;

            let activeNav: JQuery<HTMLElement> = undefined;

            navItems.each((_, item) => {
                const section = $(item).attr('href');
                const targetSection = $(section);
                if (!targetSection.length) return; // Skip if the section is invalid

                const sectionTop = targetSection.offset().top;
                const targetOffset = sectionTop - navheight - padHeight;

                if (scrollY >= targetOffset) {
                    activeNav = $(item);
                }
            });

            if (activeNav) {
                navItems.removeClass('active'); // Remove 'active' from all items
                activeNav.addClass('active'); // Add 'active' to the current item
            }
        });
    }

    openExternalLink(link: string) {
        window.open(link, "_blank");
    }

    scrollToSection(id: string) {
        const targetSection = $(`#${id}`);
        if (!targetSection) return; // Ensure the href is valid

        const navbar = $("header").find("nav");
        let navheight = navbar.outerHeight();
        let padHeight = 50;

        const sectionOffset = $(targetSection).offset().top;

        let targetOffset = sectionOffset - navheight - padHeight;
        if (targetOffset < 0) targetOffset = 0;

        $('html, body').animate({ scrollTop: targetOffset }, 800);
    }

    viewDocument(link: string, title: string = ""): void {
        $("#filename").text(title);
        let iframe = this.documentViewModal.find("#document-iframe");
        iframe.attr("src", link);
        this.documentViewModal.modal("show");
    }

    viewVideo(captionLink: string, noCaptionLink: string, title: string = ""): void {
        let captionBtn = this.viewVideoModal.find("#video-caption-select");
        let noCaptionBtn = this.viewVideoModal.find("#video-no-caption-select");
        let videoFrame = this.viewVideoModal.find("#video-iframe");
        //let videoTrack = this.viewVideoModal.find("#video-track");
        let videoTitle = this.viewVideoModal.find("#video-title");

        // default
        videoTitle.text(title);
        captionBtn.removeClass("active");
        noCaptionBtn.addClass("active");
        videoFrame.attr("src", noCaptionLink);
        //videoTrack.attr("src", captionLink);
       
        // btn functionality
        captionBtn.off().on("click", () => {
            if (captionBtn.hasClass("active")) return;

            videoFrame.attr("src", captionLink);
            noCaptionBtn.removeClass("active");
            captionBtn.addClass("active");
        });

        noCaptionBtn.off().on("click", () => {
            if (noCaptionBtn.hasClass("active")) return;

            videoFrame.attr("src", noCaptionLink);
            captionBtn.removeClass("active");
            noCaptionBtn.addClass("active");
        });

        this.viewVideoModal.modal('show');
    }

    initializeViewDocumentModal(): void {
        this.documentViewModal.on("hide.bs.modal", () => {
            $("#filename").text("");
            let iframe = this.documentViewModal.find("#document-iframe");
            iframe.attr("src", "");
        })

        this.viewVideoModal.on("hide.bs.modal", () => {
            let videoFrame = this.viewVideoModal.find("#video-iframe");
            videoFrame.attr("src", "");
        })
    }

    initializeConnectForm(): void {
        this.connectForm = <HTMLFormElement>document.getElementById("connect-with-us-form");
        this.connectModal = $("#connect-with-us-modal");
        this.connectSubmitBtn = this.connectModal.find("#connect-with-us-submit");
        this.connectSpinner = this.connectModal.find("#submit-spinner");
        this.connectSuccessBlock = this.connectModal.find(".success-block");
        this.connectErrorBlock = this.connectModal.find(".error-block");

        this.connectModal.on("show.bs.modal", () => {
            // reset form
            this.connectForm.reset();
            this.connectSubmitBtn.prop('disabled', true);

            // Hide Success & Error & Loading
            this.connectSubmitBtn.removeClass('d-none');
            this.connectSpinner.addClass("d-none");
            this.connectErrorBlock.addClass('d-none');
            this.connectSuccessBlock.addClass("d-none");
        })

        let textarea = this.connectModal.find("textarea");
        textarea.on("change keyup", (e) => {
            let currentTextarea = $(e.currentTarget);
            if (currentTextarea.val().trim() == "") {
                this.connectSubmitBtn.prop("disabled", true);
            }
            else {
                this.connectSubmitBtn.prop("disabled", false);
            }
        })

        $(".open-connect-form-btn").on("click", () => {
            this.connectModal.modal('show');
        })

        $("#connect-with-us-form").on("submit", async (e) => {
            e.preventDefault();
            await this.submitConnectForm();
        })
    }


    async submitConnectForm(): Promise<any> {
        // Hide Error Blocks
        this.connectErrorBlock.empty();
        this.connectErrorBlock.addClass("d-none");
        this.connectSuccessBlock.addClass('d-none');

        // Show Spinner
        this.connectSubmitBtn.addClass('d-none');
        this.connectSpinner.removeClass('d-none');

        let formData = new FormData(this.connectForm);

        let result = await $.ajax("/secure/data-sharing/data-sharing-hub?handler=SubmitConnectForm", {
            method: "POST",
            headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
        });

        // Logic for errors
        if (result) {
            let errorMessages = <string[]>result;
            let errorDisplay = errorMessages.join("<br>");
            this.connectErrorBlock.empty().html(errorDisplay);
            this.connectErrorBlock.removeClass('d-none');
            this.connectSubmitBtn.removeClass("d-none");
        }
        else {
            this.connectSpinner.addClass("d-none");
            this.connectSuccessBlock.removeClass("d-none");
            this.connectForm.reset();
            this.connectSubmitBtn.prop("disabled", true)
        }

        return result;
    }

    
}

export class DataHubFileView {
    documentViewModal: JQuery<HTMLElement>;
    constructor() {
        $(() => {
            this.documentViewModal = $("#view-document-modal");

            this.initializeViewDocumentModal();
        })
    }

    viewDocument(link: string, title: string = ""): void {
        $("#filename").text(title);
        let iframe = this.documentViewModal.find("#document-iframe");
        iframe.attr("src", link);
        this.documentViewModal.modal("show");
    }

    initializeViewDocumentModal(): void {
        this.documentViewModal.on("hide.bs.modal", () => {
            $("#filename").text("");
            let iframe = this.documentViewModal.find("#document-iframe");
            iframe.attr("src", "");
        })
    }
}